import { render, staticRenderFns } from "./ItemCardPage.vue?vue&type=template&id=f2c2c194&scoped=true"
import script from "./ItemCardPage.vue?vue&type=script&lang=js"
export * from "./ItemCardPage.vue?vue&type=script&lang=js"
import style0 from "./ItemCardPage.vue?vue&type=style&index=0&id=f2c2c194&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2c2c194",
  null
  
)

export default component.exports